import React, { useState, useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../../redux/hooks';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components 

import Box from '@mui/material/Box';

interface Props { 
    icon: React.ReactNode; 
    handler: any, 
    isDisabled?: boolean; 
    title: string; 
}; 

const Action: React.FC<Props> = ({ icon, handler, isDisabled, title }) => {

    const dispatch = useAppDispatch(); 
    const { t } = useTranslation(); 
    const navigate = useNavigate(); 

    const colors = useAppSelector(state => state.theme.colors); 

    // -- 

    const voidFunction = () => { 
      return; 
    };

    // -- 

    return (

      <Box 
        onClick={isDisabled ? voidFunction : handler}
        sx={{ 
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center', 
            justifyContent: 'space-evenly', 
            padding: 1,
            borderRadius: 3, 
            cursor: isDisabled ? 'default' : 'pointer', 
            color: isDisabled ? colors?.sectionHover : colors?.main,
            '&:hover': { 
              backgroundColor: isDisabled ? 'transparent' : colors?.sectionHover,
            }
      }}>

        {icon}

        <Box
          sx={{ 
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            fontSize: 10
          }}
        >{t(title)}

        </Box>

      </Box>

  );

};

export default Action;